export class ResultsController {
	constructor($scope, searchService) {
		this.service = searchService;
		this.docs = [];

		$scope.$watchCollection( () => {
			return searchService.getResults();
		}, () => {
			this.docs = searchService.getResults();
		});
	}
}

ResultsController.$inject = ['$scope', 'searchService'];
